export default [
    {
        id: 'ball-position-point',
        type: 'circle',
        source: 'ball-position',
        paint: {
            'circle-radius': [
                'interpolate',
                ['exponential', 0.5],
                ['zoom'],
                10,
                3,
                20,
                5,
            ],
            'circle-color': ['get', 'color'],
            'circle-stroke-color': ['get', 'strokecolor'],
            'circle-stroke-width': 1,
        },
        filter: [
            'all',
            ['==', ['get', 'isVisible'], true],
            ['==', ['geometry-type'], 'Point'],
        ],
        minzoom: 12,
    },
    {
        id: 'ball-position-title',
        type: 'symbol',
        source: 'ball-position',
        layout: {
            'symbol-placement': 'point',
            'text-field': ['get', 'title'],
            'text-size': 13,
        },
        paint: {
            'text-color': '#eee',
            'text-halo-color': 'rgba(0,0,0,0.6)',
            'text-halo-width': 1.5,
        },
        style: {
            glyphs: '',
        },
        filter: [
            'all',
            ['==', ['get', 'isVisible'], true],
            ['==', ['get', 'labelState'], 'on'],
        ],
        minzoom: 16,
    },
];
